import { isEmpty } from 'lodash';
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

const FollowingAndFollwers = ({userDetails}) => {
  const { t } = useTranslation()
  const location = useLocation()
  const [userData, setUserData] = useState(
    !isEmpty(location.state?.userDetails)
    ? location.state?.userDetails
    : userDetails
    );
  return (
    <div className=' grid grid-cols-3 text-start'>
      <div className=''>
        <div className='text-3xl'>{t('O_FOLLOWERS')}</div>
        <div className='text-2xl mt-4'>{userData?.followers?.length}</div>
      </div>
      <div className=''>
        <div className='text-3xl'>{t('O_FOLLOWINGS')}</div>
        <div className=' text-2xl mt-4'>{userData?.followings?.length}</div>
      </div>
    </div>
    
  )
}

export default FollowingAndFollwers